import React, { useState } from 'react';
import style from './index.module.css';
import { forgetPassword } from '../../services/AuthService';
const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError('');
      setMessage('');
      const response = forgetPassword(email);  
      setMessage(response.Message); // Show success message
    } catch (err) {
      setError(err?.response?.data?.Message || 'Xəta baş verdi'); // Display the error message
    }
  };

  return (
    <div>
      <div className={style.form}>
        <div className={style.img}>
          <a href=''>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/logo/logo.png' alt="logo" />
          </a>
        </div>
        <div className={style.geri}>
          <a href='/login'>
            <i className="fa-solid fa-arrow-left"></i>
          </a>
        </div>
        <div className={style.sign}>
          <p>Already a Member? <a href='/Registr'>Sign In</a></p>
        </div>
      </div>
      <div className={style.sign1}>
        <h2>Forgot Password?</h2>
        <p>Enter the email address you used when you joined and we’ll send you instructions to reset your password.</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className={style.group}>     
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <span className={style.highlight}></span>
          <span className={style.bar}></span>
          <label>Email</label>
        </div>
        <div className={style.button}>
          <button type="submit">Send Reset Instructions</button>
        </div>
      </form>

      {message && <p>{message}</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <div className={style.form1}>
        <p>We Offer the Best Products</p>
      </div>
      <div className={style.hed}></div>
    </div>
  );
};

export default ForgetPassword;
